// useBeneficiosListagem.js
import { useLatestAsyncRequest } from '@spark/ui-components/hooks/useLatestAsyncRequest'
import { useState, useEffect, useCallback } from 'react'
import { getBeneficios } from '@spark/services/recrutamento-rh'

// Mapeia UI -> API (somente Categoria)
function mapUiToApi(ui = {}) {
  const out = {}
  if (ui.Categoria && ui.Categoria.trim()) out.categoria = ui.Categoria.trim()
  return out
}

export const useBeneficiosListagem = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [filterLoading, setFilterLoading] = useState(false)
  const [totalRegistros, setTotalRegistros] = useState(0)
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [quantidadePorPagina, setQuantidadePorPagina] = useState(20)

  // ✅ só Categoria
  const [filtrosUI, setFiltrosUI] = useState({
    Categoria: '',
  })

  const { beginRequest, isCurrentRequest, isMounted } = useLatestAsyncRequest()

  const fetchData = useCallback(async (
    pagina = paginaAtual,
    limite = quantidadePorPagina,
    ui = filtrosUI
  ) => {
    if (!isMounted()) return

    const requestId = beginRequest()
    try {
      setLoading(true)

      const apiFilters = mapUiToApi(ui)
      const res = await getBeneficios({ page: pagina, limit: limite, ...apiFilters })

      if (!isCurrentRequest(requestId)) return

      const registros = res?.registros ?? []
      const total = res?.totalRegistros ?? 0

      const dados = registros.map(b => ({
        id: b.id ?? b.Id,
        Categoria: b.Categoria,
        Nome: b.Nome,
      }))

      setData(dados)
      setTotalRegistros(Number(total) || 0)
    } catch (e) {
      if (!isCurrentRequest(requestId)) return
      setData([])
      setTotalRegistros(0)
    } finally {
      if (isCurrentRequest(requestId)) {
        setLoading(false)
        setFilterLoading(false)
      }
    }
  }, [beginRequest, filtrosUI, isCurrentRequest, isMounted, paginaAtual, quantidadePorPagina])

  useEffect(() => {
    fetchData(paginaAtual, quantidadePorPagina, filtrosUI)
  }, [fetchData])

  const handleFilterApply = useCallback((newUiFilters) => {
    setFiltrosUI(newUiFilters)
    setPaginaAtual(1)
    setFilterLoading(true)
    fetchData(1, quantidadePorPagina, newUiFilters)
  }, [fetchData, quantidadePorPagina])

  const handleLimparFiltros = useCallback(() => {
    const cleared = { Categoria: '' }
    setFiltrosUI(cleared)
    setPaginaAtual(1)
    setFilterLoading(true)
    fetchData(1, quantidadePorPagina, cleared)
  }, [fetchData, quantidadePorPagina])

  return {
    data,
    loading,
    filterLoading,
    totalRegistros,
    paginaAtual,
    quantidadePorPagina,
    filtrosUI,
    handleFilterApply,
    handleLimparFiltros,
    setPaginaAtual,
    setQuantidadePorPagina,
    refetch: () => fetchData(paginaAtual, quantidadePorPagina, filtrosUI),
  }
}
